<template>
  <div>
    <vx-card
      title="Фильтры"
      class="p-1 mb-3 passes__filter-card"
      style="background: #e3e6fd"
      collapseAction
    >
      <div class="flex flex-wrap items-center justify-start w-full">
        <div class="header-filter md:w-3/12 md:px-2 w-full mb-2 cursor-pointer">
          <v-select
            @input="getInvoices()"
            :options="countItemsOmPage"
            :clearable="false"
            placeholder="Количество товаров"
            style="background-color: #fff"
            v-model="countElements"
          >
            <div slot="no-options">Совпадений не найдено</div>
          </v-select>
        </div>
        <div class="header-filter md:w-3/12 md:px-2 w-full mb-2 cursor-pointer">
          <vs-input
            class="w-full"
            placeholder="Номер участка"
            v-model="filter.home__homestead_number"
          />
        </div>
        <div class="header-filter md:w-3/12 md:px-2 w-full mb-2 cursor-pointer">
          <v-select
            @input="filterBills"
            label="name"
            :options="countyType"
            :reduce="(name) => name.id"
            :clearable="true"
            v-model="filter.home__county_type"
            placeholder="Выбор поселения"
            style="background-color: #fff"
          >
            <div slot="no-options">Совпадений не найдено</div>
          </v-select>
        </div>
        <div class="header-filter md:w-3/12 md:px-2 w-full mb-2 cursor-pointer">
          <v-select
            placeholder="Сортировка"
            @input="filterBills"
            label="name"
            :options="orderingData"
            :reduce="(name) => name.id"
            :clearable="true"
            v-model="filter.ordering"
            style="background-color: #fff"
          >
            <div slot="no-options">Совпадений не найдено</div>
          </v-select>
        </div>
        <div
          class="
            header-filter
            md:w-1/4
            md:px-2
            w-full
            mb-2
            cursor-pointer
            relative
          "
        >
          <flat-pickr
            class="block w-full"
            :config="configdateTimePickerFilter"
            placeholder="Дата создания от"
            v-model="filter.start_date_created"
          />
          <button
            v-if="filter.start_date_created"
            type="button"
            title="Очистить"
            aria-label="Очистить"
            class="vs__clear absolute mr-0 h-4"
            style="top: 50%; right: 15px; transform: translateY(-50%)"
            @click="filter.start_date_created = ''"
          >
            <feather-icon icon="XIcon" svgClasses="" class="w-4 h-4" />
          </button>
        </div>
        <div
          class="
            header-filter
            md:w-1/4
            md:px-2
            w-full
            mb-2
            cursor-pointer
            relative
          "
        >
          <flat-pickr
            class="block w-full"
            :config="configdateTimePickerFilter"
            placeholder="Дата создания до"
            v-model="filter.end_date_created"
          />
          <button
            v-if="filter.end_date_created"
            type="button"
            title="Очистить"
            aria-label="Очистить"
            class="vs__clear absolute mr-0 h-4"
            style="top: 50%; right: 15px; transform: translateY(-50%)"
            @click="filter.end_date_created = ''"
          >
            <feather-icon icon="XIcon" svgClasses="" class="w-4 h-4" />
          </button>
        </div>

        <div
          class="
            header-filter
            md:w-1/4
            md:px-2
            w-full
            mb-2
            cursor-pointer
            relative
          "
        >
          <flat-pickr
            class="block w-full"
            :config="configdateTimePickerFilter"
            placeholder="Дата платежа от"
            v-model="filter.start_date_payed"
          />
          <button
            v-if="filter.start_date_payed"
            type="button"
            title="Очистить"
            aria-label="Очистить"
            class="vs__clear absolute mr-0 h-4"
            style="top: 50%; right: 15px; transform: translateY(-50%)"
            @click="filter.start_date_payed = ''"
          >
            <feather-icon icon="XIcon" svgClasses="" class="w-4 h-4" />
          </button>
        </div>
        <div
          class="
            header-filter
            md:w-1/4
            md:px-2
            w-full
            mb-2
            cursor-pointer
            relative
          "
        >
          <flat-pickr
            class="block w-full"
            :config="configdateTimePickerFilter"
            placeholder="Дата платежа до"
            v-model="filter.end_date_payed"
          />
          <button
            v-if="filter.end_date_payed"
            type="button"
            title="Очистить"
            aria-label="Очистить"
            class="vs__clear absolute mr-0 h-4"
            style="top: 50%; right: 15px; transform: translateY(-50%)"
            @click="filter.end_date_payed = ''"
          >
            <feather-icon icon="XIcon" svgClasses="" class="w-4 h-4" />
          </button>
        </div>
      </div>
    </vx-card>

    <vx-card :title="`Счета | Всего ${totalBills}`" class="p-6">
      <vs-row class="mb-10">
        <vs-button @click="activeSendInvoice = true" color="primary"
          >Выставить счета</vs-button
        >
      </vs-row>
      <vs-table
        :data="bills"
        :stripe="true"
        :search="false"
        :pagination="false"
        :maxItems="20"
        noDataText="Элементов не найдено"
      >
        <template slot="thead">
          <vs-th> Данные плательщика </vs-th>
          <vs-th> Стоимость </vs-th>
          <vs-th> Статус </vs-th>
          <vs-th> Описание </vs-th>
          <vs-th> Даты </vs-th>
          <vs-th> Действия </vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr :key="indextr" v-for="(tr, indextr) in data">
            <vs-td>
              <p class="mb-3">
                Поселок:
                <span class="text-primary">{{
                  data[indextr].home.county_type.name
                }}</span>
              </p>
              <p class="mb-3">
                Номер участка:
                <span class="text-primary">{{
                  data[indextr].home.homestead_number
                }}</span>
              </p>
              <p v-if="data[indextr].home.address" class="mb-3">
                Адрес:
                <span class="text-primary">{{
                  data[indextr].home.address
                }}</span>
              </p>
            </vs-td>

            <vs-td>
              {{ data[indextr].price }}
            </vs-td>

            <vs-td>
              <vs-chip v-if="data[indextr].is_paid" color="success"
                >Оплачен</vs-chip
              >
              <vs-chip v-else color="danger">Не оплачен</vs-chip>
            </vs-td>

            <vs-td>
              {{ data[indextr].description }}
            </vs-td>

            <vs-td>
              <p class="mb-3">
                Дата создания счета:
                <span class="text-primary">{{
                  data[indextr].date_created
                }}</span>
              </p>
              <p
                class="mb-3"
                v-if="data[indextr].is_paid && data[indextr].date_payed"
              >
                Дата оплаты:
                <span class="text-primary">{{ data[indextr].date_payed }}</span>
              </p>
            </vs-td>

            <vs-td>
              <vx-tooltip class="inline-block" text="Открыть">
                <vs-button
                  :href="`/communal-payments/bills/${data[indextr].id}`"
                  color="dark"
                  class="text-dark"
                  icon-pack="feather"
                  icon="icon-external-link"
                  size="large"
                  type="flat"
                ></vs-button>
              </vx-tooltip>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
      <vs-pagination
        class="mt-4"
        :total="totalPagePagination"
        v-model="currentPagingationPage"
      ></vs-pagination>
    </vx-card>

    <vs-popup
      title="Загрузить счета"
      :active.sync="activeSendInvoice"
      :button-close-hidden="true"
    >
      <p class="mb-5">
        <label class="block mb-2">Загрузить файл</label>
        <input
          type="file"
          id="file"
          ref="file"
          accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
          v-on:change="handleFileUpload()"
        />
      </p>
      <template v-if="errorsResponse.length > 0">
        <p class="mb-3">
          Счета успешно выставлены для
          <span
            v-for="(success, index) in successResponse"
            :key="index"
            class="text-success"
          >
            <template v-if="index + 1 == successResponse.length">
              {{ success }}.
            </template>
            <template v-else> {{ success }}, </template>
          </span>
        </p>
      </template>
      <template v-if="errorsResponse.length > 0">
        <p class="mb-3">
          Не удалось выставить счёт для ЛС
          <span
            v-for="(error, index) in errorsResponse"
            :key="index"
            class="text-danger"
          >
            <template v-if="index + 1 == errorsResponse.length">
              {{ error }}.
            </template>
            <template v-else> {{ error }}, </template>
          </span>
        </p>
      </template>
      <vs-button
        :disabled="!validateUploadForm"
        @click="createInvoices"
        color="primary"
        class="mr-5"
        >Выставить счета</vs-button
      >
      <vs-button
        @click="activeSendInvoice = false"
        color="primary"
        type="border"
        >Закрыть</vs-button
      >
    </vs-popup>
  </div>
</template>
<script>
import { API_URL, countyType, countItemsOmPage } from "@/.env";
import { DateTime } from "luxon";

import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import { Russian as RussianLocale } from "flatpickr/dist/l10n/ru.js";

export default {
  data: () => ({
    BASE_URL: API_URL,
    countyType,
    bills: [],

    fileExcel: null,

    configdateTimePickerFilter: {
      enableTime: false,
      dateFormat: "d.m.Y",
      noCalendar: false,
      locale: RussianLocale,
    },

    orderingData: [
      { id: "date_created", name: "↑Дата создания" },
      { id: "-date_created", name: "↓Дата создания" },
      { id: "date_payed", name: "↑Дата оплаты" },
      { id: "-date_payed", name: "↓Дата оплаты" },
    ],

    filter: {
      ordering: "",
      start_date_payed: null,
      end_date_payed: null,
      start_date_created: null,
      end_date_created: null,
      home__homestead_number: "",
      home__county_type: "",
    },
    countElements: 20,
    currentPagingationPage: 1,
    totalBills: 0,
    totalPagePagination: 1,
    countItemsOmPage,

    activeSendInvoice: false,
    errorsResponse: [],
    successResponse: [],
  }),
  components: {
    flatPickr,
  },
  watch: {
    filter: {
      handler(val) {
        this.filterBills();
      },
      deep: true,
    },
    countElements: function () {
      this.currentPagingationPage = 1;
      this.getInvoices();
    },
    currentPagingationPage: function () {
      this.getInvoices();
    },
  },
  computed: {
    validateUploadForm() {
      return this.fileExcel !== null && this.fileExcel !== undefined;
    },
  },
  methods: {
    filterBills: _.debounce(function () {
      this.currentPagingationPage = 1;
      this.getInvoices();
    }, 1500),
    notification(title, message, color) {
      this.$vs.notify({
        title: title,
        text: message,
        color: color,
        position: "top-center",
        time: "4000",
        icon: "delete",
      });
    },
    getInvoices() {
      this.$vs.loading();

      this.filter.page =
        this.currentPagingationPage !== 1 ? this.currentPagingationPage : 1;
      this.filter.limit = this.countElements !== 20 ? this.countElements : 20;

      let payload = _.clone(this.filter, true);

      if (payload.start_date_payed) {
        payload.start_date_payed = DateTime.fromFormat(
          payload.start_date_payed,
          "dd.MM.yyyy"
        ).toISODate();
      }

      if (payload.end_date_payed) {
        payload.end_date_payed = DateTime.fromFormat(
          payload.end_date_payed,
          "dd.MM.yyyy"
        ).toISODate();
      }

      if (payload.start_date_created) {
        payload.start_date_created = DateTime.fromFormat(
          payload.start_date_created,
          "dd.MM.yyyy"
        ).toISODate();
      }

      if (payload.end_date_created) {
        payload.end_date_created = DateTime.fromFormat(
          payload.end_date_created,
          "dd.MM.yyyy"
        ).toISODate();
      }

      this.$load(async () => {
        let res = (await this.$api.communalPayments.getInvoices(payload)).data;

        this.totalBills = res.count;
        this.totalPagePagination = Math.ceil(
          this.totalBills / this.countElements
        );

        res.results.forEach((invoice) => {
          invoice.date_created = DateTime.fromISO(
            invoice.date_created
          ).toFormat("dd.MM.yyyy");

          if (invoice.date_payed) {
            invoice.date_payed = DateTime.fromISO(invoice.date_payed).toFormat(
              "dd.MM.yyyy"
            );
          }

          invoice.home.county_type = countyType.find(
            (x) => x.id == invoice.home.county_type
          );
        });

        this.bills = res.results;
        this.$vs.loading.close();
      });
    },
    handleFileUpload() {
      this.fileExcel = this.$refs.file.files[0];
    },
    createInvoices() {
      this.$load(async () => {
        try {
          if (this.fileExcel) {
            let response = (
              await this.$api.communalPayments.uploadFile({
                fileExcel: this.fileExcel,
              })
            ).data;
            if (response.errors) {
              this.errorsResponse = [];
              response.errors.forEach((error) => {
                let err = error.match(
                  /user with this personal account (.*?) was not found/
                )[1];

                this.errorsResponse.push(err);
              });
            }

            if (response.invoices) {
              this.successResponse = [];

              response.invoices.forEach((invoice) => {
                invoice.home.county_type = countyType.find(
                  (x) => x.id == invoice.home.county_type
                );
                let msg = `${invoice.home.county_type.name}, участок #${invoice.home.homestead_number}`;
                this.successResponse.push(msg);
                this.bills.splice(0, 0, invoice);
              });
            }
          } else {
            this.notification("Внимание", "Файл не выбран", "warning");
          }
        } catch (error) {
          console.log(error);
          this.notification("Ошибка", "Не удалось загрузить файл", "danger");
        }
      });
    },
  },
  mounted() {
    this.getInvoices();
  },
};
</script>